import { motion } from "framer-motion";
import { ArrowUpRight, BadgeCheck } from "lucide-react";
import { ENDORSEMENT } from "@/data";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

export default function Endorsement() {
  return (
    <section
      id="endorsement"
      data-testid="endorsement-section"
      className="relative border-t border-neutral-900 bg-[#070707]"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-24">
        <div className="grid grid-cols-1 items-stretch gap-0 border border-red-900/40 bg-[#0B0B0B] lg:grid-cols-[1.1fr_0.9fr]">
          <motion.a
            variants={reveal}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            data-testid="endorsement-photo-link"
            href={ENDORSEMENT.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${ENDORSEMENT.brand} — pagina endorser di ${ENDORSEMENT.member}`}
            className="group relative block min-h-[280px] overflow-hidden sm:min-h-[380px]"
          >
            <img
              src={ENDORSEMENT.photo}
              alt={`Piatto ${ENDORSEMENT.brand} personalizzato: incisione "${ENDORSEMENT.member} — Linea Cremisi"`}
              className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#0B0B0B]/90" />
            <span className="absolute left-5 top-5 inline-flex items-center gap-2 border border-red-900/60 bg-black/60 px-3 py-1.5 font-mono-tac text-[10px] uppercase tracking-[0.3em] text-red-500 backdrop-blur">
              <BadgeCheck className="h-3.5 w-3.5" />
              Endorser ufficiale
            </span>
          </motion.a>

          <motion.div
            variants={reveal}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            className="flex flex-col justify-center p-8 sm:p-12"
          >
            <p className="font-mono-tac text-xs uppercase tracking-[0.35em] text-red-600">
              Endorsement
            </p>
            <h2 className="font-display mt-4 text-4xl uppercase leading-[0.95] text-neutral-100 sm:text-6xl">
              {ENDORSEMENT.member}
              <br />
              <span className="text-outline-red">×</span>{" "}
              <span className="text-[#C8102E]">{ENDORSEMENT.brand}</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-neutral-400">
              Il nostro batterista è endorser ufficiale {ENDORSEMENT.brand}.
              Sul palco e in studio suona la serie{" "}
              <span className="text-neutral-200">{ENDORSEMENT.series}</span> —
              china, crash, hi-hats, ride e splash — con un piatto inciso a
              mano con il suo nome e il nostro: Linea Cremisi, in bronzo.
            </p>
            <a
              data-testid="endorsement-link"
              href={ENDORSEMENT.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex w-fit items-center gap-3 border border-neutral-700 px-6 py-3.5 font-mono-tac text-xs uppercase tracking-[0.25em] text-neutral-200 transition-all duration-200 hover:border-red-600 hover:text-red-500 hover:shadow-[0_0_20px_rgba(200,16,46,0.35)]"
            >
              La pagina endorser
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
